<template>
  <span v-if="activityText">
    <b-icon
      icon="camera-video-fill"
      :font-scale="fontScale"
      variant="success"
      v-if="
        activityText.includes('video') &&
        (activityText.includes('open') || activityText.includes('start'))
      "
    ></b-icon>
    <b-icon
      icon="envelope-open-fill"
      :font-scale="fontScale"
      v-else-if="
        activityText.includes('conversation') && activityText.includes('opened')
      "
    ></b-icon>

    <b-icon
      icon="chat-right-text"
      variant="danger"
      :font-scale="fontScale"
      v-else-if="
        activityText.includes('conversation') && activityText.includes('close')
      "
    ></b-icon>
    <b-icon
      icon="geo-alt-fill"
      :font-scale="fontScale"
      v-else-if="activityText.includes('location')"
    ></b-icon>

    <b-icon
      icon="telephone-inbound"
      variant="success"
      :font-scale="fontScale"
      v-else-if="activityText.includes('joined')"
    ></b-icon>
    <b-icon
      icon="camera-video-off"
      variant="danger"
      :font-scale="fontScale"
      v-else-if="activityText.includes('left')"
    ></b-icon>
    <b-icon
      icon="telephone-x-fill"
      variant="danger"
      :font-scale="fontScale"
      v-else-if="activityText.includes('disconnected')"
    ></b-icon>
    <b-icon
      icon="telephone-plus-fill"
      variant="success"
      :font-scale="fontScale"
      v-else-if="activityText.includes('connected')"
    ></b-icon>
    

    <b-icon
      icon="camera-video-off-fill"
      variant="danger"
      :font-scale="fontScale"
      v-else-if="
        activityText.includes('video') &&
        (activityText.includes('close') || activityText.includes('end'))
      "
    ></b-icon>
    <b-icon
      icon="shield-lock"
      variant="warning"
      :font-scale="fontScale"
      v-else-if="
        activityText.includes('video') &&
        activityText.includes('request shared')
      "
    ></b-icon>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24"
      height="24"
      v-else-if="activityText.includes('updated language')"
    >
      <path
        fill="currentColor"
        d="M12,2C6.48,2,2,6.48,2,12s4.48,10,10,10s10-4.48,10-10S17.52,2,12,2z M12,20c-4.41,0-8-3.59-8-8s3.59-8,8-8s8,3.59,8,8S16.41,20,12,20z"
      />
      <path
        fill="currentColor"
        d="M12,6c-0.55,0-1,0.45-1,1s0.45,1,1,1s1-0.45,1-1S12.55,6,12,6z"
      />
      <path
        fill="currentColor"
        d="M16,12h-3v-3c0-0.55-0.45-1-1-1s-1,0.45-1,1v3H8c-0.55,0-1,0.45-1,1s0.45,1,1,1h3v3c0,0.55,0.45,1,1,1s1-0.45,1-1v-3h3 c0.55,0,1-0.45,1-1S16.55,12,16,12z"
      />
    </svg>

    <b-icon icon="camera" :font-scale="fontScale" v-else></b-icon>
  </span>
</template>

<script>
export default {
  name: "ActivitiesIcons",
  props: {
    activityText: String,
    fontScale: Number,
  },
  data() {
    return {};
  },
  created() {},
  computed: {},
};
</script>

<style scoped>
</style>
